import React from 'react';

import { JJTErrorCodes } from '@common/errors/jjtErrorCodes';
import { ErrorPropType } from '../../shared/jim/propTypes';

const JobErrorDetails = ({
  error,
}) => {
  switch (error && error.code) {
    case JJTErrorCodes.ROW_LEVEL_VALIDATION:
      return error
        && error.details
        && error.details.errors
        && error.details.errors.map((error, index) => <JobErrorDetails error={error} key={index}/>);

    case JJTErrorCodes.ROW_LEVEL_SCHEMA_VALIDATION:
      return (
        <div><b>{error.details.message}</b> in row {error.details.rowIndex + 2}</div>
      );

    case JJTErrorCodes.VALIDATION_COLUMN_VALIDATION: {
      const invalidColumns = error.details.map((column, index) => (
        <div key={index}>&nbsp;&nbsp;{`expected: ${column.expected}, found: ${column.found}`}</div>
      ));
      return (
        <div><b>Invalid columns:</b> {invalidColumns} </div>
      );
    }

    case JJTErrorCodes.VALIDATION_INCORRECT_COMPANY_CODE:
      return (
        <div><b>Invalid Company Code</b> {error.details.companyCode} in row number {error.details.rowIndex + 2}</div>
      );

    case JJTErrorCodes.VALIDATION_INCORRECT_PERIOD:
      return (
        <div>
          <b>Invalid Period</b> {error.details.rowPeriod} in row number {error.details.rowIndex + 2},
          expected {error.details.correctPeriod}
        </div>
      );

    case JJTErrorCodes.NO_VALID_TRIAL_BALANCE_IMPORTED:
      return (
        <div>
          <b>Import failed</b>
          <br/>
          No rows were imported for selected period and company code.
        </div>
      );

    case JJTErrorCodes.DATASET_LEVEL_VALIDATION:
      return (
        <div className="whitespace-pre-wrap"> {error.details.message} </div>
      );

    default:
      if (error && error.details) {
        if (error.details.rowIndex) {
          return (
            <div>Unknown Error in row number {error.details.rowIndex + 2}</div>
          );
        }
        if (error.details.message) {
          return (
            <div className="whitespace-pre-wrap">{ error.details.message }</div>
          );
        }
      }
      return (
        <div>Unknown Error, try again later</div>
      );
  }
};

JobErrorDetails.propTypes = {
  error: ErrorPropType,
};

export default JobErrorDetails;
